/* Otervano V23.8. Visual hook only; native cart requests/listeners are untouched.
   Promotion and shipping are now rendered in Liquid with each native cart section update.
   No forced 100% bar, no text replacement, no document-wide MutationObserver. */
(() => {
  'use strict';
  const refresh = () => document.querySelectorAll('cart-drawer, .cart-drawer').forEach((drawer) => drawer.classList.add('ov-cart-premium-ready'));
  window.__ovCartPremium = { refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  document.addEventListener('shopify:section:load', refresh);
})();
